'use client'

import DisablePrefetchLink from '@component/disablePrefetchLink'
import { houseDetail } from '@router'
import HouseFacility from '../facility'
import { concat, first, get, map } from 'lodash-es'
import { TagItem } from '../tags'
import { Favourite } from '../favourite'
import Cover from '@component/cover'
import classNames from 'classnames'
import { isVillageData } from '@utils/house'
import { exitFullscreen, joinStr } from '@utils'
import TrackButton from '../track'
import { mapDataLayer } from '@plugin/google/gtm/modules/estimate'
import { useCallback } from 'react'

export default function ListingsMap({
  list,
  isForSale = false,
  isRent = false,
  isSold = false,
  isEstimate = false,
  isRv = false
}) {

  return (
    <div className="max-h-320 overflow-auto space-y-10">
      {
        map(list, (item, idx) => (
          <Card
            data={item}
            key={idx}
            isForSale={isForSale}
            isRent={isRent}
            isSold={isSold}
            isEstimate={isEstimate}
            isRv={isRv}
          ></Card>
        ))
      }
    </div>
  )
}

function Card({
  data,
  isForSale = false,
  isRent = false,
  isSold = false,
  isEstimate = false,
  isRv = false,
  className
}) {
  const cover = first(concat(get(data, 'images'), get(data, 'floorPlanImages')))
  const isVillage = isVillageData(data)
  const priceLabel = isVillage ? data.teaser : joinStr([data.priceBold, data.priceLight], ' ')

  const viewListingsClick = useCallback(() => {
    exitFullscreen()
    localStorage.setItem('map-listing-click', JSON.stringify(data))
  }, [data])

  return (
    <div className={classNames('block rounded-sm overflow-hidden group shadow-md w-266', className)}>
      <a href={houseDetail(data)} onClick={viewListingsClick} aria-label='go to property'>
        {
          cover && (
            <div className='relative'>
              <div className='absolute z-[1] left-0 top-0 p-10 w-full pointer-events-none'>
                <div className='flex items-start justify-between pointer-events-auto'>
                  <Tag
                    isForSale={isForSale}
                    isRent={isRent}
                    isSold={isSold}
                    isEstimate={isEstimate}
                    isRv={isRv}
                  ></Tag>
                  {
                    (isForSale || isRent) && (
                      <Favourite data={data}></Favourite>
                    )
                  }
                </div>
              </div>
              <Cover src={cover} alt={data.teaser} className='aspect-[266/140]' width={266} height={140}></Cover>
            </div>
          )
        }
        <div className='p-10'>
          {
            !cover && (
              <Tag
                isForSale={isForSale}
                isRent={isRent}
                isSold={isSold}
                isEstimate={isEstimate}
                isRv={isRv}
              ></Tag>
            )
          }
          {
            priceLabel && <div className='text-sm text-font font-bold line-clamp-1'>{priceLabel}</div>
          }
          <div className='mt-4'>
            <address className='text-xs not-italic line-clamp-1'>{data.address}</address>
          </div>
          <div className='mt-8'>
            <HouseFacility data={data}></HouseFacility>
          </div>
        </div>
      </a>
      <div className='flex gap-x-10 p-10 pt-0'>
        {
          isEstimate && <TrackButton data={{ ...data, propertyId: data.id }} signupSource='Track_Home' className='flex-1 !text-xs !h-28' onClick={mapDataLayer.trackClick}></TrackButton>
        }
        <a href={houseDetail(data)} className='flex-1 !text-xs !h-28 button-orange' onClick={viewListingsClick}>{isEstimate || isSold ? 'More detail' : 'View Listing'}</a>
      </div>
    </div>
  )
}

function Tag({
  isForSale,
  isRent,
  isSold,
  isEstimate,
  isRv
}) {

  if (isForSale) return <TagItem className='bg-secondary'>For sale</TagItem>
  if (isRent) return <TagItem className='bg-purple'>Rent</TagItem>
  if (isSold) return <TagItem className='bg-red'>Sold</TagItem>
  if (isEstimate) return <TagItem className='bg-estimate'>Estimate</TagItem>
  if (isRv) return <TagItem className='bg-font-secondary2'>Rateable value</TagItem>
}

export function ListingsMapSkeleton() {
  return (
    <div className='skeleton-wrap w-266 space-y-6'>
      <span className='aspect-video'></span>
      <span className='h-10 w-3/4'></span>
      <span className='h-10 w-1/2'></span>
      <span className='h-10 w-1/3'></span>
    </div>
  )
}